import React from 'react';
import { FormattedMessage } from 'react-intl';

import theme from './OptionalTitle.scss';

const OptionalTitle = () => (
  <span className={ theme.root }>
    <span>&nbsp;(</span>
    <FormattedMessage
      id="General.Optional"
      defaultMessage="** optional"
    />
    <span>)</span>
  </span>
);

export default OptionalTitle;
